import React, { FC, useEffect, useState } from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Button, Typography } from '@mui/material';
import MailchimpFormContainer from "../../MailChimp/MailChimpForm";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { TwitterQuestModal } from "./TwitterQuestModal"
import { getGoogleFormQuestLink } from '../../../commands/quest/getGoogleFormQuest';
import { useWallet } from '@solana/wallet-adapter-react';

//
function QuestCheckbox(props: any) {
    return (
        <>
            {props.checked && <CheckCircleOutlineIcon sx={{ fontSize: "19px", position: "relative", top: 4, opacity: 0.7 }} />}
            {!props.checked && <RadioButtonUncheckedIcon sx={{ fontSize: "19px", position: "relative", top: 4, opacity: 0.7 }} />}
        </>
    )
}

// Component
function Quests(props: any) {
    const theme = useTheme();
    //const isSmall = useMediaQuery(theme.breakpoints.down(650));
    //const [address, setAddress] = React.useState<null | string>(null);
    const { publicKey } = useWallet();
    const [openMainChimp, setOpenMainChimp] = React.useState(false);
    const [openTwitterQuest, setOpenTwitterQuest] = React.useState(false);

    //
    function callStartQuestFn(fnName: string) {
        if (startQuestFn[fnName]) {
            startQuestFn[fnName]();
        }
    }

    //
    const startQuestFn: any = {
        createUser: () => {
            var walletBtn = document.getElementsByClassName("wallet-adapter-button");

            if (walletBtn && walletBtn.length > 0) {
                (walletBtn[0] as HTMLElement).click();
            }
        },
        joinml: () => {
            setOpenMainChimp(true);
            setTimeout(() => { setOpenMainChimp(false); }, 100); // reset!
        },
        joinDiscord: () => {
            window.open('https://discord.com/invite/eternaldragons', "_self");
        },

        followUsOnTwitter: () => {
            setOpenTwitterQuest(true);
        },
        googlequest4: () => {
            if (publicKey) {
                let adr = publicKey.toBase58();
                getGoogleFormQuestLink(adr, 'googlequest4').then((link) => {
                    console.log(`https://docs.google.com/forms/d/e/1FAIpQLSelHdxen_Gt6RvqJ_dG9QCU66bNMPN-QfSVrl8vVYiykgfpbg/viewform?usp=pp_url&entry.643563265=${link.data.token}`);
                    window.open(`https://docs.google.com/forms/d/e/1FAIpQLSelHdxen_Gt6RvqJ_dG9QCU66bNMPN-QfSVrl8vVYiykgfpbg/viewform?usp=pp_url&entry.643563265=${link.data.token}`, "_self");
                })
            }
        },
        googlequest6: () => {
            if (publicKey) {
                let adr = publicKey.toBase58();
                getGoogleFormQuestLink(adr, 'googlequest6').then((link) => {
                    console.log(`https://docs.google.com/forms/d/13iPbxyC2uRI9bpm7BTf8E2C-vKfW6piHF4fKSuPd3HY/viewform?usp=pp_url&entry.1266551241=${link.data.token}`);
                    window.open(`https://docs.google.com/forms/d/13iPbxyC2uRI9bpm7BTf8E2C-vKfW6piHF4fKSuPd3HY/viewform?usp=pp_url&entry.1266551241=${link.data.token}`, "_self");
                })
            }
        },
        googlequest7: () => {
            if (publicKey) {
                let adr = publicKey.toBase58();
                getGoogleFormQuestLink(adr, 'googlequest7').then((link) => {
                    console.log(`https://docs.google.com/forms/d/12OzHGpS4KsYxvCDgRwiXE910V00V7EOGRH9g4zDl65I/viewform?usp=pp_url&entry.1266551241=${link.data.token}`);
                    window.open(`https://docs.google.com/forms/d/12OzHGpS4KsYxvCDgRwiXE910V00V7EOGRH9g4zDl65I/viewform?usp=pp_url&entry.1266551241=${link.data.token}`, "_self");
                })
            }
        }
    }

    //
    return (
        <Box className={props.className}>
            <Box className="home-front-dragon-container home-gate-bg-img" style={{ position: "relative" }}>

                <MailchimpFormContainer autoCloseOnSuccess={false} showJoinBtn={false} updateQuests={props.updateQuests} open={openMainChimp} />

                <TwitterQuestModal
                    open={openTwitterQuest}
                    handleClose={() => setOpenTwitterQuest(false)}
                    afterSuccess={(res: any, twitterUserName: string) => { props.updateQuests(res, true); props.setUserTwitter(twitterUserName) }}
                />

                {/* Congrat user */}
                {props.celebrateQuests &&
                    <Box style={{ width: "100%", height: "100%", position: 'absolute', zIndex: 100, top: 0, right: 0, textAlign: "center" }}>
                        <img style={{ height: "100%" }} src="celeb3.gif" />
                    </Box>}

                {/* Quests box */}
                <Box className="whitelist-quest-cont">

                    <Box className="whitelist-quest-header">
                        <Box sx={{ fontSize: "24px", margin: "0px 10px 0px 10px", color: "white" }}>Quests</Box>
                    </Box>

                    <Box style={{ maxWidth: "350px", fontSize: "16px", lineHeight: 1.1, margin: "10px 0px 30px 0px" }}>
                        Participate in our quests to unlock more exciting tasks, earn Eternium and compete for a Whitelist spot
                    </Box>

                    {
                        props.quests.quests.map((c: any) => {
                            return (
                                <Box className="whitelist-quests-quest" style={{ position: "relative" }} key={c.id}>

                                    <Box sx={{ display: "flex", justifyContent: "space-between", color: "white", alignItems: "center" }}>
                                        <Box sx={{ fontWeight: 700, fontSize: "15px" }}>
                                            <QuestCheckbox checked={c.status === 2} /> {c.title}
                                        </Box>
                                    </Box>

                                    <Box sx={{ fontWeight: 700, fontSize: "14px", color: "#b1bac5" }}>{c.desc}</Box>

                                    {
                                        c.status !== 2 &&
                                        <Box style={{ marginTop: "10px", color: "white" }}>
                                            <Button onClick={() => callStartQuestFn(c.startQuestFn)} className="whitelist-discord-btn" variant="contained">Start Quest</Button>
                                        </Box>
                                    }
                                </Box>
                            );
                        })
                    }

                    <Box style={{ marginTop: "40px" }}></Box>

                    {/* Corner ornaments */}
                    <Box className="whitelist-corner-cont" style={{ top: -15, right: -15 }}>
                        <img alt="quests-bubble-dragon-ornament" src="ornaments/eternium_golden_dragon.png" style={{ width: "80%", position: "absolute", opacity: 0.3 }} />
                    </Box>

                    <Box className="whitelist-corner-cont" style={{ top: -15, left: -15, transform: "scaleX(-1)" }}>
                        <img alt="quests-bubble-dragon-ornament" src="ornaments/eternium_golden_dragon.png" style={{ width: "80%", position: "absolute", opacity: 0.3 }} />
                    </Box>

                    <Box className="whitelist-corner-cont" style={{ bottom: -15, right: -15 }}>
                        <img alt="quests-bubble-dragon-ornament" src="ornaments/eternium_golden_dragon.png" style={{ width: "80%", position: "absolute", opacity: 0.3 }} />
                    </Box>

                    <Box className="whitelist-corner-cont" style={{ bottom: -15, left: -15, transform: "scaleX(-1)" }}>
                        <img alt="quests-bubble-dragon-ornament" src="ornaments/eternium_golden_dragon.png" style={{ width: "80%", position: "absolute", opacity: 0.3 }} />
                    </Box>
                </Box>

            </Box>
        </Box>
    );
}

// Default style!
const QuestsStyled = styled(Quests)({
    ".home-front-dragon-container": {
        paddingTop: "30px",
        position: "relative",
        background: "grey",
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100%",
        padding: "0px 30px 0px 30px"
    },
    ".home-gate-bg-img": {
        backgroundImage: "url(eternaldragons_website_illustration_02_sm.jpg)",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 60%",
        height: "1000px"
    },
    ".whitelist-corner-cont": {
        boxShadow: "0px 0px 3px 1px #172330",
        fontWeight: 700,
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "26px",
        marginLeft: "0px",
        height: "50px",
        width: "50px",
        borderRadius: 100,
        background: "#182d42",
        opacity: 0.95
    },
    ".whitelist-quest-cont": {
        position: "relative",
        width: "380px",
        height: "auto",
        //minHeight: "600px",
        background: "#182d42",
        opacity: 0.95,
        borderRadius: 20,
        padding: "15px",
        textAlign: "center",
        boxShadow: "0px 0px 3px 1px #172330"
    },
    ".whitelist-quest-header": {
        padding: "10px",
        fontSize: "20px",
        fontWeight: 700,
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    ".whitelist-quests-quest": {
        boxShadow: "0px 0px 3px 1px #374b68",
        opacity: 1,
        background: "#1c324b",
        borderRadius: "5px",
        textAlign: "left",
        padding: "10px",
        margin: "20px 0px 20px 0px"
    },
    ".whitelist-discord-btn": {
        fontWeight: 700,
        fontSize: "12px",
        background: "#2e455e",
        color: "white",
        border: "1px solid #233a53",
        "&:hover": {
            background: "#395370"
        }
    },
    ['@media (max-width:480px)']: {
        ".whitelist-quest-cont": {
            position: "relative",
            minWidth: "10px",
            maxWidth: "400px",
            width: "auto",
            height: "auto",
            //minHeight: "600px",
            background: "#182d42",
            opacity: 0.95,
            borderRadius: 20,
            padding: "15px",
            textAlign: "center",
            boxShadow: "0px 0px 3px 1px #172330"
        }
    }
});

// Export
export default QuestsStyled;